<div class="download-header">
  <inline-svg src="downloads.svg"></inline-svg>
  <p>
    Exposure Reports
  </p>
</div>

<div class="download-table">
  <div class="table-header">
    <span>My reports</span>
    <mat-form-field appearance="outline">
      <inline-svg src="search.svg" matPrefix></inline-svg>
      <input matInput [formControl]="reportSearchCtrl" placeholder="Search by report name">
    </mat-form-field>
  </div>
  <div class="table-container">
    <table mat-table [dataSource]="reportData" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)"
      matSortActive="created_at" matSortDirection="desc" matSortDisableClear [trackBy]="reportTrackBy">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Report Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name | truncate: 50 }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="created_at">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Date and time</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.created_at | date: "dd/M/yyyy, HH:mm" }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="area_count">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Total AOIs
          <span class="icon icon-info" matTooltip="Total AOIs processed"
          matTooltipPosition="left"></span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>{{ element.area_count }} </span>
          <!--                    <img src="assets/icons/aoi.svg"-->
          <!--                         alt="" width="12px"-->
          <!--                         height="12px">-->
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef mat-sort-header>AOI's in threshold
          <span class="icon icon-info" matTooltip="AOI's within threshold"
          matTooltipPosition="left"></span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>{{ element.count }} </span>
          <!--                    <img src="assets/icons/aoi.svg"-->
          <!--                         alt="" width="12px"-->
          <!--                         height="12px">-->
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef> Status</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="status-block">
            <inline-svg [src]="statusClass(element) +'.svg'" [class]="statusClass(element)+'-icon'"></inline-svg>
            <span>{{ element.status.toLowerCase() !== 'failed' ? element.status.toLowerCase() : "No match" }}</span>
            @if (element.status.toLowerCase() == 'processing') {
              <span style="font-weight: 700"> {{ element.percentage_complete?.toFixed(0) }}
                %
              </span>
            }
          </div>
          @if (element.status.toLowerCase() == 'failed') {
            <inline-svg src="info.svg" class="info-icon" [matTooltip]="errorText"
            ></inline-svg>
          }

        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="shared">
        <mat-header-cell *matHeaderCellDef ></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="shared-users">
            @for (user of getUsersWithAccess(element); track user) {
              @if ($index < 2) {
                <frmg-user-logo
                  [ngClass]="{'owner': element.user.email !== currentUser.email && $index == 0}"
                  [user]="user"
                ></frmg-user-logo>
              }
              @if ($index === 2) {
                <frmg-user-logo [user]="moreUsers(element)"
                ></frmg-user-logo>
              }
            }
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element" class="report-actions" [ngClass]="{'menu-open': menuState === element.id}">
          <inline-svg src="Hamburger_menu.svg"
            [matMenuTriggerFor]="downloadMenu"
            #menuOpen='matMenuTrigger'
          (click)="toggleMenu(element, $event)"></inline-svg>
          <mat-menu #downloadMenu="matMenu" xPosition="before" class="download-menu-panel"
            (closed)="toggleMenu(null)">
            @if (element.status.toLowerCase() == 'completed') {
              @if (element.user?.email === currentUser.email) {
                <span (click)="share(element, $event)">Share</span>
              }
              <!--                            <span (click)="downloadPdf(element.id, element.name+'_report', $event)"> Download in PDF</span>-->
              <span (click)="downloadXLSX(element.id, element.name+'_report', $event)"> Download in XLSX</span>
            }
              <span (click)="deleteReport(element, $event)">Delete forever</span>
            <!--                            <span *ngIf="element.user.email !== currentUser.email" (click)="unShareReport(element, $event)">Remove from the list</span>-->
          <!--                        </ng-container>-->
        </mat-menu>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns; let $index = index;" (click)="goToReport(row)"
      (mouseenter)="setHoverId($index)" (mouseleave)="setHoverId(null)"
    [ngClass]="{'show_actions': $index == hoverId , 'hide_click_mouse': row.status.toLowerCase() !== 'completed'}"></mat-row>
  </table>
</div>
<mat-divider></mat-divider>
<mat-paginator
  [length]="totalElements"
  [pageIndex]="currentPage-1"
  [pageSize]="pageSize"
  [pageSizeOptions]="[10, 20, 30]"
  [showFirstLastButtons]="true"
  (page)="handlePageEvent($event)"
></mat-paginator>

</div>

